import { render, staticRenderFns } from "./ReviewCardTooltips.vue?vue&type=template&id=c45e6b98&scoped=true&"
import script from "./ReviewCardTooltips.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ReviewCardTooltips.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ReviewCardTooltips.vue?vue&type=style&index=0&id=c45e6b98&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c45e6b98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c45e6b98')) {
      api.createRecord('c45e6b98', component.options)
    } else {
      api.reload('c45e6b98', component.options)
    }
    module.hot.accept("./ReviewCardTooltips.vue?vue&type=template&id=c45e6b98&scoped=true&", function () {
      api.rerender('c45e6b98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuReviews/components/ReviewCardTooltips.vue"
export default component.exports